import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const WelcomeModal = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: "16px",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "16px 24px",
          fontFamily: "Merriweather, serif",
          fontWeight: 700,
          fontSize: "24px",
        }}
      >
        <Box sx={{ fontSize: "32px", marginRight: "16px" }}>👋</Box>
        Hello There!
        <IconButton
          onClick={onClose}
          sx={{ marginLeft: "auto" }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: "8px 24px 24px" }}>
        <Typography
          sx={{
            marginBottom: "24px",
            fontFamily: "Poppins, sans-serif",
            fontSize: "16px",
            lineHeight: 1.5,
          }}
        >
          30 questions on this page are designed to analyse your career wellness
          and to unlock tailored insights just for you. Takes less than 3
          minutes to complete.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              bgcolor: "#DF7468",
              color: "#FFFFFF",
              borderRadius: "5px",
              px: "24px",
              py: "12px",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 500,
              fontSize: "16px",
              textTransform: "none",
              "&:hover": {
                bgcolor: "#DF7468",
                opacity: 0.9,
              },
            }}
          >
            Got It!
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeModal;
